import React from 'react';
import './HeaderStuffButton.css';

function HeaderStuffButton(props) {
  return (
    <button className="HeaderStuffButton" onClick={props.onClick}>
      <h5>my stuff</h5>
      <i className="fa fa-chevron-down fa-lg"/>
    </button>
  );
}

export default HeaderStuffButton;



// WEBPACK FOOTER //
// ./src/components/HeaderStuffButton/HeaderStuffButton.js